export default (function () {
  let callbacks = []
  let running = false

  function resize () {
    if (!running) {
      running = true

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(runCallbacks)
      } else {
        setTimeout(runCallbacks, 66)
      }
    }
  }

  function runCallbacks () {
    callbacks.forEach(callback => callback())
    running = false
  }

  function addCallback (callback) {
    if (callback) {
      callbacks.push(callback)
    }
  }

  function removeCallback () {
    callbacks = []
  }

  return {
    add: function (callback) {
      if (!callbacks.length) {
        window.addEventListener('resize', resize)
      }
      addCallback(callback)
    },
    remove: function () {
      window.removeEventListener('resize', resize)
      removeCallback()
    }
  }
}())
